export const YES_NO_OPTIONS = (vueObject) => [
    { id: 0, text: vueObject.$t("dashboard.menu.eventDetails.no") },
    { id: 1, text: vueObject.$t("dashboard.menu.eventDetails.yes") }
]; 

export const TRUE_FALSE_OPTIONS = (vueObject) => [
    { id: 0, text: vueObject.$t("common.false") },
    { id: 1, text: vueObject.$t("common.true") }
]; 